var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClass,attrs:{"role":"separator"}},[(_vm.$slots.default)?_c('div',{staticClass:"p-divider-content"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }